import API from "./API";

export default class Import extends API
{
    static async import(params) {
        return this.post("api/admin/import/add", params);
    }
    
    
}